export const PICKUP_CHIP_ANCHOR_ID = 'pickup-action-chip-anchor'
